import React from 'react'
import FTextField from './FTextField'
import FYesNoField from './FYesNoField'
import FCurrencyField from './FCurrencyField'
import FDisplayValueField from './FDisplayValueField'
import FDateTimeField from './FDateTimeField'
import FDateDurationField from './FDateDurationField'
import FEmailField from './FEmailField'
import FEntityListField from './FEntityListField'
import FListField from './FListField'
import FNumericAutoIncrementField from './FNumericAutoIncrementField'
import FNumericField from './FNumericField'
import FNumericFormulaField from './FNumericFormulaField'
import FNumericCalculationField from './FNumericCalculationField'
import FTimeCalculationActionField from './FTimeCalculationActionField'
import FTimeDurationActionField from './FTimeDurationActionField'
import FApUserField from './FApUserField'

const FieldTypeRequiredFields = ({data, setData, type, onChange = (e, key, value) => {}}) => {
  switch (type) {
    case 'TextField':
      return <FTextField onChange={onChange} data={data} />
    case 'YesNoField':
      return <FYesNoField onChange={onChange} data={data} />
    case 'CurrencyField':
      return <FCurrencyField onChange={onChange} data={data} />
    case 'DateField':
    case 'DateTimeField':
      return <FDateTimeField onChange={onChange} data={data} />
    case 'DisplayValueField':
      return <FDisplayValueField onChange={onChange} data={data} />
    case 'DateDurationField':
      return <FDateDurationField onChange={onChange} data={data} />
    case 'EmailField':
      return <FEmailField onChange={onChange} data={data} />
    case 'EntityListField':
    case 'MultipleEntityListField':
      return <FEntityListField onChange={onChange} data={data} setData={setData} />
    case 'ListField':
    case 'MultipleListField':
      return <FListField onChange={onChange} data={data} />
    case 'NumericField':
      return <FNumericField onChange={onChange} data={data} />
    case 'NumericAutoIncrementField':
      return <FNumericAutoIncrementField onChange={onChange} data={data} />
    case 'NumericFormulaField':
      return <FNumericFormulaField onChange={onChange} data={data} />
    case 'NumericCalculationField':
      return <FNumericCalculationField onChange={onChange} data={data} />
    case 'TimeCalculationActionField':
      return <FTimeCalculationActionField onChange={onChange} data={data} />
    case 'TimeDurationActionField':
      return <FTimeDurationActionField onChange={onChange} data={data} />
    case 'ApUserField':
      return <FApUserField onChange={onChange} data={data} />
    default:
      return null
  }
}

export default FieldTypeRequiredFields
